import editIcon from "../../assets/icons/edit-light.svg";

const PortalDealDetailsEditToolbar = ({ isEditMode, onEdit, onSave, onCancel, sending }) => {
    if (!isEditMode) {
        return (
            <div className="deal_details_form__edit_button">
                <button className="deal_details_form__edit_btn" type="button" onClick={onEdit}>
                    <img src={editIcon} alt="" />
                    <span>Edit</span>
                </button>
            </div>
        );
    }

    return (
        <div className="deal_details_form__edit_button">
            <div className="deal_details_form__edit_actions">
                <button
                    type="button"
                    className="deal_details_form__edit_btn deal_details_form__save_btn"
                    onClick={onSave}
                    disabled={sending}
                >
                    Save changes
                </button>
                <button
                    type="button"
                    className="deal_details_form__edit_btn deal_details_form__cancel_btn"
                    onClick={onCancel}
                    disabled={sending}
                >
                    Cancel
                </button>
            </div>
        </div>
    );
};

export default PortalDealDetailsEditToolbar;
